import { LogoSvg } from "./logo-svg";
import { cn } from "@/lib/cn";
import { cevir } from "@/lib/dil";

/**
 * Yükleme perdesi: kelime markası harf harf çizilir.
 * Her harfin konturu soldan sağa çizilir (stroke-dashoffset), hemen ardından içi dolar;
 * turuncu "I" sona kalır, yerine oturur ve üstünden ışık geçer.
 * `prefers-reduced-motion` açıksa hareket yok, logo doğrudan durur.
 */
export function YuklemePerdesi({ mesaj = cevir("Loading"), tamEkran = true }: { mesaj?: string; tamEkran?: boolean }) {
  return (
    <div className={cn("flex items-center justify-center bg-bg font-plex", tamEkran ? "min-h-dvh" : "min-h-[50vh] w-full")}>
      <div className="flex flex-col items-center gap-6">
        <LogoAnimasyon />
        <p className="text-sm text-ink-3">
          {mesaj}
          <span className="nokta">.</span>
          <span className="nokta nokta-2">.</span>
          <span className="nokta nokta-3">.</span>
        </p>
      </div>
    </div>
  );
}

export function LogoAnimasyon({ height = 46 }: { height?: number }) {
  return (
    <div className="logo-sahne relative">
      <LogoSvg height={height} animasyon />
      <span className="parilti" aria-hidden />
    </div>
  );
}
